<div [style]="display">
  <div class="overlay-spinner">
    <mat-spinner id="spinner-animation">
    </mat-spinner>
  </div>
</div>
<ng-content></ng-content>
